
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Modal, Image } from 'semantic-ui-react'
import { getHasError, getError } from '../selectors'
import { setError } from '../actions'
import { logout } from '../../auth/actions'
import { clearBSRSToken } from 'Lib'
require('../../../scss/modalErrorMessageDialog.scss')

class ErrorMessage extends React.Component {
	state = { open: this.props.hasError, error: this.props.error }

	close = () => {
		this.setState({ open: false })
		let code = this.state.error ? this.state.error.code : ""
		if (code === "401" || code === "00002143")
			this.props.logout()
		this.props.clearError()
	}

	componentWillReceiveProps(nextProp) {
		this.setState({ open: nextProp.hasError, error: nextProp.error })
	}

	render() {
		return (
			<Modal open={this.state.open} onClose={this.close} size="small">
				{/* <Modal.Header>System Message</Modal.Header> */}
				<Modal.Content style={{ height: 'auto' }}>
					{/* {
						this.props.hasError
						&& this.props.error != null
						&& this.props.error.code !== undefined
						&& this.props.error.message !== undefined
						&& <Modal.Description>
							<p>Error Code : {this.props.error.code}</p>
							<p>Error Message : {this.props.error.message}</p>
						</Modal.Description>
					} */}
					<div className="errormessage">
						<div className="contenterror">
							<div className="content-image">
								<Image src='/assets/images/icon-warning-red.png' />
							</div>
							<div className="content-text">
								<p></p>
								{
									this.props.hasError
										&& this.props.error != null
										&& this.props.error.code !== undefined
										&& this.props.error.message !== undefined ?
										<p>{this.props.error.message}</p>
										: <p>Something went wrong.</p>

								}
							</div>
						</div>
						<div className="close" onClick={this.close}>
							<Image src='/assets/images/icon-cross-red.png' />
						</div>
					</div>
				</Modal.Content>
				{/* <Modal.Actions>
					<Button
						positive
						icon='checkmark'
						labelPosition='right'
						content="OK"
						onClick={this.close}
						onClose={this.close}
					/>
				</Modal.Actions> */}
			</Modal>
		)
	}
}

export default compose(
	connect(
		(state, props) => ({
			hasError: getHasError(state),
			error: getError(state),
		}),
		(dispatch) => ({
			clearError() {
				dispatch(setError(false))
			},
			logout() {
				dispatch(logout())
				clearBSRSToken()
				window.location.replace('/')
			}
		})
	)
)(ErrorMessage)


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessageDialog.js